module.exports = __webpack_public_path__ + "static/savantus-logo-7ccfec84c6ad3e606db2dc2cabbdb0c5.png";